import React from "react";
import { useHistory } from "react-router-dom";

import { Table } from "../../../../../../components";
import { useECColumns, useECRequests } from "../../hooks";

export const MyRequestsTable = () => {
  const history = useHistory();
  const { requests } = useECRequests();
  const { columns } = useECColumns();

  return (
    <Table
      columns={columns}
      dataSource={requests}
      rowKey="requestId"
      onRow={() => ({
        onClick: () => history.push("/procedure/employee-confirmation/1"),
      })}
    />
  );
};
